import type { ProductoAgregado } from "../types/product";

export function calcularTotalesDeRenglon(p: ProductoAgregado) {
  const qty = Number(p.cantidad || 0);
  const unit = Number(p.precio || p?.concepto?.valor_unitario || 0);
  const subtotal = Number(p.importe ?? qty * unit);
  const descuento = Number(p.descuento || 0);

  const totalTraslados =
    (p.impuestos?.traslados || [])?.reduce(
      (a, t) => a + Number(t?.importe || 0),
      0
    ) || 0;
  const totalRetenciones =
    (p.impuestos?.retenciones || [])?.reduce(
      (a, r) => a + Number(r?.importe || 0),
      0
    ) || 0;
  const impuestosFederales = totalTraslados - totalRetenciones;

  const totalLocalesTras =
    (p.implocales?.traslados || [])?.reduce(
      (a, l) => a + Number(l?.importe || 0),
      0
    ) || 0;
  const totalLocalesRet =
    (p.implocales?.retenciones || [])?.reduce(
      (a, l) => a + Number(l?.importe || 0),
      0
    ) || 0;
  const impuestosLocales = totalLocalesTras - totalLocalesRet;

  const total = subtotal - descuento + impuestosFederales + impuestosLocales;
  return { subtotal, descuento, impuestosFederales, impuestosLocales, total };
}
